import styled from "styled-components";

export const SubtitleStyled = styled.span`
    font-size: 14px;
    font-weight: 300;
    letter-spacing: -0.4px;
    line-height: 18.2px;
    color: #475466;
`;

